import type { VehicleData } from 'Pages/vehicles/helpers/vehicle.schema';
import { ForSaleCategory, UnsoldCategory } from 'Types/enquiryStates';
import { FOR_SALE_CATEGORY } from 'Utilities/vehicleState';

export const VEHICLE_PURCHASE_TYPES = {
	PROXY: 'PROXY',
	SALE: 'SALE',
} as const;

export type GetSaleType = keyof typeof VEHICLE_PURCHASE_TYPES | '';

export const getSaleType = (state: VehicleData['state']): GetSaleType => {
	if (state.slug === FOR_SALE_CATEGORY.SALE_ACTIVE || state.slug === ForSaleCategory.underOffer) {
		return VEHICLE_PURCHASE_TYPES.PROXY;
	}
	if (state.slug === FOR_SALE_CATEGORY.FOR_SALE || state.slug === UnsoldCategory.unsoldBelowReserveBid) {
		return VEHICLE_PURCHASE_TYPES.SALE;
	}

	return '';
};
